import { axios } from 'src/lib/axios';
import { errorHandler } from 'src/utils/Error';
import { API_URL } from 'src/config';


export const getRoutes = (params) => {
  return axios(`${API_URL}/admin/routes`, { params }).catch((error) =>
    errorHandler(error),
  );
};

export const getRoute = (id) => {
  return axios(`${API_URL}/admin/routes/${id}`).catch((error) => errorHandler(error));
};

export const createRoute = (data) => {
  return axios.post(`${API_URL}/admin/routes`, data);
};

export const updateRoute = ({ id, data }) => {
  return axios.put(`${API_URL}/admin/routes/${id}`, data);
};

export const deleteRoute = (id) => {
  return axios.delete(`${API_URL}/admin/routes/${id}`);
};
